// src/components/steps/SupportTierStep.js
import React from 'react';

function SupportTierStep({ state, setState, serviceData, setCurrentStep }) {
  const isPaperless = state.emailAddress.toLowerCase().endsWith('paperlesswms.com.au');

  return (
    <div className="space-y-6">
      <div className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800">Support Tier</h2>
        <p className="text-gray-600 mt-2">Select your preferred support level</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {Object.entries(serviceData.supportTiers).map(([key, tier]) => {
          const isSelected = state.supportTier === key;
          // Adjust supportText and tier name for Paperless:
          const supportText = isPaperless ? '24x7 Support' : tier.description;
          const tierName = isPaperless ? `${tier.name.split('(')[0].trim()} (24x7)` : tier.name;


          return (
            <div
              key={key}
              className={`
                relative rounded-xl border-2 overflow-hidden transition-all
                ${isSelected
                  ? 'border-blue-500 bg-blue-50 shadow-lg'
                  : 'border-gray-200 hover:border-blue-300'}
              `}
            >
              <div className={`px-6 py-4 ${isSelected ? 'bg-blue-500' : 'bg-gray-50'}`}>
                <h3 className={`text-xl font-semibold ${isSelected ? 'text-white' : 'text-gray-900'}`}>
                  {tierName} {/* Use modified tier name */}
                </h3>
                <p className={`mt-1 text-sm ${isSelected ? 'text-blue-100' : 'text-gray-500'}`}>
                  {supportText}
                </p>
              </div>

              {/* ... (rest of the SupportTierStep.js code) ... */}
              <div className="px-6 py-4">
                <ul className="space-y-3">
                  {tier.features.map((feature, index) => {
                      let modifiedFeature = feature;
                      if (isPaperless) {
                        if (feature.startsWith('Business hours support') || feature.startsWith('Extended support')) {
                            modifiedFeature = '24x7 support';
                        }
                      }
                      return (
                    <li key={index} className="flex text-sm">
                      <svg className="h-5 w-5 text-blue-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="ml-3 text-gray-600">{modifiedFeature}</span>
                    </li>
                  );})}
                </ul>
              </div>

              <div className="px-6 py-4 bg-gray-50">
                <button
                  onClick={() => {
                    setState(prev => ({ ...prev, supportTier: key }));
                    setCurrentStep(8);
                  }}
                  className={`
                    w-full px-4 py-2 rounded-lg font-medium transition-colors
                    ${isSelected
                      ? 'bg-blue-500 text-white hover:bg-blue-600'
                      : 'bg-white text-gray-900 border border-gray-300 hover:bg-gray-50'}
                  `}
                >
                  {isSelected ? 'Selected' : 'Select'}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SupportTierStep;
